import axios from 'axios'

const token = "Bearer 2xh9qfvR4!L7";

const instance = axios.create({
  // baseURL: 'https://dev.bibomart.net/hotdeal_services'
  baseURL: 'https://prod.bibomart.net/hotdeal-services'
});

instance.interceptors.request.use(function (config) {
  config.headers.Authorization =  token;
  return config;
});

instance.interceptors.response.use((response) => {
    return response.data
}, error => {
  return Promise.resolve({ error });
  // window.localStorage.setItem('errornetwworkmsg', error);
  // return window.location.href = '/404.html';
})

export default instance;